const BEACON_V1_PATH = '/api/v1/b';
export const RECEIVE_BEACON_EVENT_PATH = `${BEACON_V1_PATH}/receive`;
